import {
  FontSelect as baseFontSelect,
  FontColor as baseFontColor,
  FontStyleSelect as baseFontStyleSelect,
  FontSize as baseFontSize,
  VerticalAlignment as baseVerticalAlignment,
  HorizontalAlignment as baseHorizontalAlignment,
} from 'apps/studio/components/settings/fields/Base/design'
import { BackgroundColor as defaultBackgroundColorConfig } from 'apps/studio/components/settings/fields/Base/design'
import { TextIcon } from '@gocanvas/gcds/icons'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const FontSelect = {
  ...baseFontSelect,
  updateType: 'globalStyles',
}

const FontColor = {
  ...baseFontColor,
  updateType: 'globalStyles',
}

const FontStyleSelect = {
  ...baseFontStyleSelect,
  updateType: 'globalStyles',
}

const FontSize = {
  ...baseFontSize,
  updateType: 'globalStyles',
}

export const VerticalAlignment = {
  ...baseVerticalAlignment,
  updateType: 'globalStyles',
}

export const HorizontalAlignment = {
  ...baseHorizontalAlignment,
  updateType: 'globalStyles',
}

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType: 'globalStyles',
}

export const designSettings = [
  SettingsLabel('Font'),
  FontSelect,
  FontSize,
  FontStyleSelect,
  FontColor,
  SettingsLabel('Alignment'),
  HorizontalAlignment,
  VerticalAlignment,
]

export const DESIGN_SETTINGS_PANEL = 'Typography'

export const DesignSettingsPanel = {
  label: DESIGN_SETTINGS_PANEL,
  icon: TextIcon,
  settings: designSettings,
}
